export default "__VITE_ASSET__B$Di3xPL__"